"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoopEvaluationsClient = void 0;
const client_core_1 = require("@statsig/client-core");
const _noop = () => {
    // noop
};
const _noopAsync = () => Promise.resolve();
const NOOP_DETAILS = { reason: 'Error' };
const _defaultEvaluation = (type) => {
    return (...args) => {
        const name = typeof args[0] === 'string' ? args[0] : args[1];
        switch (type) {
            case 'gate':
                return (0, client_core_1._makeFeatureGate)(name, NOOP_DETAILS, null);
            case 'config':
                return (0, client_core_1._makeDynamicConfig)(name, NOOP_DETAILS, null);
            case 'layer':
                return (0, client_core_1._makeLayer)(name, NOOP_DETAILS, null);
        }
    };
};
const _noopDataAdapter = {
    __primeInMemoryCache: _noop,
    attach: _noop,
    getDataSync: () => null,
    getDataAsync: () => Promise.resolve(null),
    setData: _noop,
    setDataLegacy: _noop,
    prefetchData: _noopAsync,
};
const context = {
    sdkKey: '',
    options: {},
    values: null,
    user: { userID: '' },
    errorBoundary: {},
};
const _client = {
    isNoop: true,
    loadingStatus: 'Uninitialized',
    initializeSync: _noop,
    initializeAsync: _noopAsync,
    shutdown: _noopAsync,
    flush: _noopAsync,
    updateRuntimeOptions: _noop,
    updateUserSync: _noop,
    updateUserAsync: _noopAsync,
    getContext: () => (Object.assign({}, context)),
    getAsyncContext: () => __awaiter(void 0, void 0, void 0, function* () {
        return (Object.assign(Object.assign({}, context), { session: {
                data: { sessionID: '', startTime: 0, lastUpdate: 0 },
                sdkKey: '',
            }, stableID: '' }));
    }),
    checkGate: () => false,
    getFeatureGate: _defaultEvaluation('gate'),
    getDynamicConfig: _defaultEvaluation('config'),
    getExperiment: _defaultEvaluation('config'),
    getLayer: _defaultEvaluation('layer'),
    logEvent: _noop,
    on: _noop,
    off: _noop,
    $on: _noop,
    $emt: _noop,
    dataAdapter: _noopDataAdapter,
};
exports.NoopEvaluationsClient = _client;
